// Add modules here to include them in dist/vendor.js file for improved code splitting

// IMPORTANT: babel-polyfill must be imported, but only once, so leave it imported only in this file
// *********************
import 'babel-polyfill';
// *********************

import 'style/vendor.scss';
import 'svgxuse';

import icomoon from '../ui/icomoon/fonts/icomoon.woff';
import icomoon from '../ui/icomoon/fonts/icomoon.eot';
import icomoon from '../ui/icomoon/fonts/icomoon.ttf';
import icomoon from '../ui/icomoon/fonts/icomoon.svg';


//////////////////
// WEBPACK FOOTER
// ./static/js/vendor.js
// module id = 155
// module chunks = 12